<template>
  <div class="survey-question form-field">
    <div class="survey-question-text field-name">{{ question.text }}</div>
    <template v-if="question.answer">
      <div v-if="question.answer.options.length" class="survey-question-answer field-value">
        {{ readableAnswerOptions }}, {{ question.answer.textEn || question.answer.text }}
      </div>
      <div v-else class="survey-question-answer field-value">{{ question.answer.textEn || question.answer.text }}</div>
    </template>
    <div v-else class="survey-question-answer field-value">No answer submitted.</div>    
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Question from '@/services/surveyQuestions'

export default {
  name: 'QuestionAnswer',
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    }
  },
  computed: {
    readableAnswerOptions() {
      let optionsText = []
      let answerOptions = this.question.answerOptions.filter(answerOption => this.question.answer.options.includes(answerOption.id))
      answerOptions.forEach(answerOption => {
        optionsText.push(answerOption.text)
      })
      return optionsText.join(', ')
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
